import { Capacitor } from '@capacitor/core';

const PRODUCTION_API_ORIGIN = 'https://app.daconnect.com.au';

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function getApiOrigin(): string {
  if (Capacitor.isNativePlatform()) {
    return PRODUCTION_API_ORIGIN;
  }
  return window.location.origin;
}
